<template>
    <span v-if="is_newsletter" @click="openNewsletter" :class="classes">
        <slot></slot>
    </span>
    <span v-else-if="is_footer" @click="gotoFooter" :class="classes">
        <slot></slot>
    </span>
    <a v-else-if="is_external" :href="url" :target="link_target" :key="url" :title="link_title" :class="classes">
        <slot></slot>
    </a>
    <router-link v-else :to="url" :target="link_target" :title="link_title" :key="url" :class="classes">
        <slot></slot>
    </router-link>
</template>

<script>
import { EventBus } from '@/events/bus.js';

export default {
    name: 'link-item',

    props: {
        link: Object,
        post_link: {
            type: String,
            default: '',
        },
        new_window: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            is_newsletter: false,
            is_footer: false,
            is_external: false,
            url: '',
            link_target: '',
            link_title: '',
            classes: [],
        }
    },

    methods: {
        gotoFooter() {
            this.$smoothScroll({
                scrollTo: document.querySelector('.footer'),
                duration: 500,
            })
        },
        openNewsletter() {
            EventBus.$emit('newsletter.open');
        },
        isFile (url) {
            url = new URL(url, location.origin);
            return url.pathname.split('/').pop().indexOf('.') > 0;
        },
        isExternal (url) {
            return new URL(url, location.origin).origin.indexOf(window.globals.home_url) === -1;
        },
        isEmail(url) {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(url).toLowerCase());
        },
    },

    mounted() {
        this.url = '';

        if (this.link) {
            this.classes.push(this.link.classes)
            this.url = this.link.url;
            this.link_target = this.link.target;
            this.link_title = this.link.title;
        } 
        else if (this.isEmail(this.post_link)) {
            this.url = 'mailto:' + this.post_link;
        }
        
        else {
            this.url = this.post_link.replace(window.globals.home_url, '');
        }

        if (this.url.indexOf('#join-newsletter') !== -1) {
            this.is_newsletter = true;
        }

        else if (this.url.indexOf('#footer') !== -1) {
            this.is_footer = true;
        }

        else if (this.url.indexOf(window.globals.home_url) !== -1) {
            this.url = this.url.replace(window.globals.home_url, this.$base_url);
        }

        // console.log( this.url, this.$base_url, window.globals.home_url)
        // console.log('isExternal', this.url, this.isExternal(this.url));
        // console.log('isFile', this.url, this.isFile(this.url));


        if ((this.new_window || this.isExternal(this.url) || this.isFile(this.url) || this.link_target === '_black') && !this.isEmail(this.url)) {
            this.link_target = '_black';
            this.is_external = true;
        }

    },
}

</script>